"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const PageWrapper_1 = require("@components/common/layout/PageWrapper");
const withLayout = (Component, styles = {}) => {
    return ({ routeKey, ...props }) => (React.createElement(PageWrapper_1.default, Object.assign({ routeKey: routeKey }, props, { style: styles }),
        React.createElement(Component, Object.assign({}, props))));
};
exports.default = withLayout;
